// extracted by mini-css-extract-plugin
module.exports = {"lds_dual_ring":"Loading382ec471a35a8e170567c0dc41242c20","ldsDualRing":"Loading382ec471a35a8e170567c0dc41242c20"};